"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ServiceSettings = _interopRequireDefault(require("./ServiceSettings"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * This class is used to store data about a waiting for cache request.
 */
var CacheWaitItem = /*#__PURE__*/function () {
  /**
   * Class constructor.
   *
   * @param {string} key Cache key.
   * @param {number} [maximumAllowedResolveTime] Maximum allowed resolve time. Default is 20000.
   */
  function CacheWaitItem(key) {
    var _this = this;

    var maximumAllowedResolveTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20000;

    _classCallCheck(this, CacheWaitItem);

    this.key = key;
    this.resolves = [];
    this.rejects = [];
    this.isNotFound = false;
    this.isWaiting = true;
    this.timeout = _ServiceSettings.default.debug ? setTimeout(function () {
      var key = _typeof(_this.key) === 'object' ? JSON.stringify(_this.key) : _this.key.toString();

      _this.reject(new Error('Failed to resolve item waiting for cache within the maximum allowed time of ' + maximumAllowedResolveTime / 1000 + 's. Item key: ' + key));
    }, maximumAllowedResolveTime) : null;
  }
  /**
   * Resolves all.
   *
   * @param {object} data Data to resolve with.
   */


  _createClass(CacheWaitItem, [{
    key: "resolve",
    value: function resolve(data) {
      if (this.timeout !== null) {
        clearTimeout(this.timeout);
      }

      this.timeout = null;
      this.isWaiting = false;

      var _iterator = _createForOfIteratorHelper(this.resolves),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var resolve = _step.value;
          resolve(data);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.resolves = null;
    }
    /**
     * Rejects all.
     *
     * @param {Error} error Error to reject with.
     */

  }, {
    key: "reject",
    value: function reject(error) {
      var rejects = this.rejects;

      if (this.timeout !== null) {
        clearTimeout(this.timeout);
      }

      this.timeout = null;
      this.rejects = [];

      var _iterator2 = _createForOfIteratorHelper(rejects),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var reject = _step2.value;
          reject(error);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }]);

  return CacheWaitItem;
}();

exports.default = CacheWaitItem;